export default __webpack_public_path__ + "static/media/photo--lg--72.4ce45070.jpg";